import React, { useEffect, useState, useRef } from 'react';

import LoaderScreen from '../../../Components/LoaderScreen';
import Alert from '../../../Components/Alert';
import ApiService from '../../../Utils/services';
import SideMenu from '../../../Components/SideMenu';
import Header from '../../../Components/Header';

export default function Integracoes() {
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [alert, setAlert] = useState(false);
    const [alertText, setAlertText] = useState('');
    const [alertType, setAlertType] = useState(3);
    
    const [webhookUrl, setWebhookUrl] = useState('');
    const [webhookPixUrl, setWebhookPixUrl] = useState('');
    const [apiToken, setApiToken] = useState('');
    const [copySuccess, setCopySuccess] = useState('');
    const tokenRef = useRef(null);

    useEffect(() => {
        loadUserData();
    }, []);

    const loadUserData = async () => {
        setLoading(true);
        try {
            const userDataString = sessionStorage.getItem('userData');
            if (!userDataString) {
                throw new Error('Usuário não autenticado');
            }

            const userData = JSON.parse(userDataString);
            setUserData(userData);

            // Verificar se o token já existe no userData
            if (userData.vendedor && userData.vendedor.vdr_token) {
              
                setApiToken(userData.vendedor.vdr_token);
            }

            if (userData.token) {
                // Carregar dados completos do vendedor
                try {
                    const response = await ApiService.get('me', userData.token);
                    
                   
                    
                    if (response.data && response.data.vendedor) {
                     
                        
                        // Atualizar os campos específicos de integração
                        setWebhookUrl(response.data.vendedor.vdr_webhookcobranca || '');
                        setWebhookPixUrl(response.data.vendedor.vdr_webhookpix || '');
                        setApiToken(response.data.vendedor.vdr_token || '');
                    } else if (response.data && response.data.data) {
                        // Alguns endpoints retornam os dados dentro de um objeto "data"
                    
                        const vendedor = response.data.data;
                     
                        
                        if (vendedor) {
                            // Obter os dados com os campos
                            setWebhookUrl(vendedor.vdr_webhookcobranca || '');
                            setWebhookPixUrl(vendedor.vdr_webhookpix || '');
                            setApiToken(vendedor.vdr_token || '');
                        }
                    }
                } catch (error) {
                    console.error('Erro ao carregar dados do vendedor:', error);
                }
            }
        } catch (error) {
            console.error('Erro ao carregar dados do usuário:', error);
            setAlertType(2);
            setAlertText('Erro ao carregar informações do usuário');
            setAlert(true);
        } finally {
            setLoading(false);
        }
    };

    const handleCopyToken = () => {
        if (tokenRef.current) {
            tokenRef.current.select();
            document.execCommand('copy');
            setCopySuccess('Copiado!');
            setTimeout(() => setCopySuccess(''), 2000);
        }
    };

    const salvar = async () => {
        setLoading(true);
        try {
            const userData = JSON.parse(sessionStorage.getItem('userData'));
            
            const response = await ApiService.post('atualizar-integracoes', {
                webhook_cobranca: webhookUrl,
                webhook_pix: webhookPixUrl
            }, userData.token);

            // Atualizar o userdata no sessionStorage
            const updatedUserData = {
                ...userData,
                vendedor: {
                    ...userData.vendedor,
                    vdr_webhookcobranca: webhookUrl,
                    vdr_webhookpix: webhookPixUrl
                }
            };
            sessionStorage.setItem('userData', JSON.stringify(updatedUserData));
            setUserData(updatedUserData);

            setAlertType(1);
            setAlertText('Configurações de integração atualizadas com sucesso');
            setAlert(true);
        } catch (error) {
            console.error('Erro ao salvar integrações:', error);
            setAlertType(2);
            setAlertText('Erro ao atualizar configurações de integração');
            setAlert(true);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div id="wrapper">
            <LoaderScreen visible={loading} />
            <Alert show={alert} texto={alertText} tipo={alertType} action={() => { setAlert(false) }} />
            
            <SideMenu menuAtivo="configuracoes" />
            
            <div className="body">
                <Header />
                
                <div className="dashboard mgDefault">
                    <div className="headerBtn">
                        <div>
                            <h1>Integrações</h1>
                            <p className="descricao">Gerencie suas integrações API e Webhooks</p>
                        </div>
                        <button className="btn" onClick={salvar}>
                            Salvar Configurações
                        </button>
                    </div>
                    
                    {/* Container principal com grid layout */}
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
                        {/* Coluna da esquerda */}
                        <div>
                            {/* Painel de Autenticação */}
                            <div className="panel">
                                <div className="header" style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #e3e6f0' }}>
                                    <h2 style={{ display: 'flex', alignItems: 'center' }}>
                                        <i className="fas fa-key" style={{ marginRight: '10px', color: '#4e73df' }}></i>
                                        Autenticação API
                                    </h2>
                                </div>
                                <div className="content">
                                    <div style={{ 
                                        backgroundColor: '#e8f4fe', 
                                        padding: '15px', 
                                        borderRadius: '5px', 
                                        marginBottom: '20px',
                                        border: '1px solid #d1e6fa'
                                    }}>
                                        <h4 style={{ marginTop: 0, color: '#2c7be5', fontWeight: 'bold' }}>Token de API</h4>
                                        <p style={{ fontSize: '14px', marginBottom: '15px' }}>
                                            Use este token para autenticar suas requisições à nossa API. Inclua-o no cabeçalho 
                                            <code style={{ backgroundColor: '#f1f4f9', padding: '2px 5px', borderRadius: '3px' }}>
                                                Authorization: Bearer {'{seu_token}'}
                                            </code>
                                        </p>
                                    </div>
                                    
                                    <div className="mb-3">
                                        <div style={{ 
                                            display: 'flex', 
                                            border: '1px solid #ced4da', 
                                            borderRadius: '4px', 
                                            overflow: 'hidden'
                                        }}>
                                            <input
                                                type="text"
                                                ref={tokenRef}
                                                className="form-control"
                                                value={apiToken}
                                                readOnly
                                                style={{ 
                                                    border: 'none', 
                                                    borderRadius: '0',
                                                    backgroundColor: '#f8f9fa',
                                                    fontFamily: 'monospace'
                                                }}
                                            />
                                            <button 
                                                className="btn" 
                                                type="button" 
                                                onClick={handleCopyToken} 
                                                style={{ 
                                                    backgroundColor: '#4e73df', 
                                                    color: 'white',
                                                    borderRadius: '0',
                                                    minWidth: '100px'
                                                }}
                                            >
                                                {copySuccess || <><i className="far fa-copy" style={{ marginRight: '5px' }}></i> Copiar</>}
                                            </button>
                                        </div>
                                    </div>
                                    
                                    {!apiToken && (
                                        <div style={{ 
                                            backgroundColor: '#fff3cd', 
                                            color: '#856404', 
                                            padding: '12px', 
                                            borderRadius: '4px',
                                            border: '1px solid #ffeeba',
                                            marginTop: '10px'
                                        }}>
                                            <i className="fas fa-exclamation-triangle" style={{ marginRight: '8px' }}></i>
                                            Nenhum token encontrado. Entre em contato com o suporte para solicitar um token de API.
                                        </div>
                                    )}
                                </div>
                            </div>
                            
                            {/* Painel de Documentação */}
                            <div className="panel" style={{ marginTop: '20px' }}>
                                <div className="header" style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #e3e6f0' }}>
                                    <h2 style={{ display: 'flex', alignItems: 'center' }}>
                                        <i className="fas fa-book" style={{ marginRight: '10px', color: '#4e73df' }}></i>
                                        Documentação
                                    </h2>
                                </div>
                                <div className="content">
                                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
                                        <div style={{ 
                                            backgroundColor: '#f1f4f9', 
                                            borderRadius: '50%', 
                                            width: '50px', 
                                            height: '50px', 
                                            display: 'flex', 
                                            alignItems: 'center', 
                                            justifyContent: 'center',
                                            marginRight: '15px'
                                        }}>
                                            <i className="fas fa-file-code" style={{ fontSize: '24px', color: '#4e73df' }}></i>
                                        </div>
                                        <div>
                                            <h4 style={{ margin: '0', color: '#333' }}>Collection Postman</h4>
                                            <p style={{ margin: '5px 0 0', fontSize: '14px', color: '#666' }}>
                                                Facilite sua integração com nossa API
                                            </p>
                                        </div>
                                    </div>
                                    
                                    <a 
                                        href="/docs/Wallet Exoss Modelo.postman_collection.json" 
                                        download="Wallet Exoss Modelo.postman_collection.json"
                                        className="btn"
                                        style={{ 
                                            backgroundColor: '#4e73df', 
                                            color: 'white',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: '10px 15px',
                                            borderRadius: '4px',
                                            textDecoration: 'none',
                                            marginBottom: '20px'
                                        }}
                                    >
                                        <i className="fas fa-download" style={{ marginRight: '8px' }}></i>
                                        Baixar Collection Postman
                                    </a>
                                </div>
                            </div>
                        </div>
                        
                        {/* Coluna da direita */}
                        <div>
                            {/* Painel de Webhooks */}
                            <div className="panel">
                                <div className="header" style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #e3e6f0' }}>
                                    <h2 style={{ display: 'flex', alignItems: 'center' }}>
                                        <i className="fas fa-bell" style={{ marginRight: '10px', color: '#4e73df' }}></i>
                                        Webhooks
                                    </h2>
                                </div>
                                <div className="content">
                                    <div style={{ 
                                        backgroundColor: '#e8f4fe', 
                                        padding: '15px', 
                                        borderRadius: '5px', 
                                        marginBottom: '20px',
                                        border: '1px solid #d1e6fa'
                                    }}>
                                        <h4 style={{ marginTop: 0, color: '#2c7be5', fontWeight: 'bold' }}>Notificações em tempo real</h4>
                                        <p style={{ fontSize: '14px', marginBottom: '0' }}>
                                            Configure URLs de webhook para receber notificações automáticas sobre eventos na sua conta.
                                        </p>
                                    </div>
                                    
                                    <div className="form-group" style={{ marginBottom: '25px' }}>
                                        <label style={{ 
                                            fontWeight: '600', 
                                            color: '#333', 
                                            marginBottom: '8px', 
                                            display: 'block' 
                                        }}>
                                            <i className="fas fa-file-invoice-dollar" style={{ marginRight: '8px', color: '#4e73df' }}></i>
                                            Webhook de Cobranças
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="https://seu-site.com/webhook/cobrancas"
                                            value={webhookUrl}
                                            onChange={(e) => setWebhookUrl(e.target.value)}
                                            style={{ 
                                                padding: '10px 15px',
                                                borderColor: '#d1d3e2'
                                            }}
                                        />
                                        <small style={{ 
                                            display: 'block', 
                                            marginTop: '8px', 
                                            color: '#858796',
                                            fontSize: '13px' 
                                        }}>
                                            <i className="fas fa-info-circle" style={{ marginRight: '5px' }}></i>
                                            Receba notificações sobre pagamentos, cancelamentos e outras atualizações relacionadas a cobranças.
                                        </small>
                                    </div>
                                    
                                    <div className="form-group">
                                        <label style={{ 
                                            fontWeight: '600', 
                                            color: '#333', 
                                            marginBottom: '8px', 
                                            display: 'block' 
                                        }}>
                                            <i className="fas fa-qrcode" style={{ marginRight: '8px', color: '#4e73df' }}></i>
                                            Webhook de PIX
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="https://seu-site.com/webhook/pix"
                                            value={webhookPixUrl}
                                            onChange={(e) => setWebhookPixUrl(e.target.value)}
                                            style={{ 
                                                padding: '10px 15px',
                                                borderColor: '#d1d3e2'
                                            }}
                                        />
                                        <small style={{ 
                                            display: 'block', 
                                            marginTop: '8px', 
                                            color: '#858796',
                                            fontSize: '13px' 
                                        }}>
                                            <i className="fas fa-info-circle" style={{ marginRight: '5px' }}></i>
                                            Receba notificações sobre pagamentos PIX em tempo real.
                                        </small>
                                    </div>
                                </div>
                            </div>
                            
                            {/* Painel de Exemplo de Payload */}
                            <div className="panel" style={{ marginTop: '20px' }}>
                                <div className="header" style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #e3e6f0' }}>
                                    <h2 style={{ display: 'flex', alignItems: 'center' }}>
                                        <i className="fas fa-code" style={{ marginRight: '10px', color: '#4e73df' }}></i>
                                        Exemplo de Payload
                                    </h2>
                                </div>
                                <div className="content">
                                    <p style={{ fontSize: '14px', marginBottom: '15px' }}>
                                        Quando um pagamento for processado, enviaremos um payload similar a este para o seu webhook:
                                    </p>
                                    <div style={{ 
                                        backgroundColor: '#2d3748', 
                                        padding: '15px', 
                                        borderRadius: '4px',
                                        overflowX: 'auto',
                                        fontFamily: 'monospace',
                                        fontSize: '14px',
                                        marginBottom: '0',
                                        color: '#e2e8f0',
                                        border: '1px solid #1a202c'
                                    }}>
<pre style={{ margin: 0 }}>{JSON.stringify({
    "type": "update",
    "mode": "pix",
    "data": {
        "payment_id": "104914140330",
        "status": 1,
        "status_text": "APPROVED",
        "amount_received": 2,
        "liquid_amount": 1.18,
        "payment_method": "pix",
        "created_at": "2025-03-12 09:33:30",
        "updated_at": "2025-03-12 14:33:19"
    }
}, null, 4)}</pre>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}